<template>
  <div :class="selector"
       class="file-show">

    <!-- VIDEO -->
    <template v-if="isFileVideo">
      <video v-bind="$attrs"
             v-on="$listeners"
             :controls="!onlyShow"
             class="file-show__file">
        <source :src="value.path">
        Your browser does not support the video tag.
      </video>
      <img v-if="onlyShow"
           class="file-show__play"
           src="@/assets/img/svg/play-small.svg"
           alt="play">
    </template>

    <!-- PDF -->
    <object v-else-if="isFilePdf"
            v-bind="$attrs"
            v-on="$listeners"
            :data="value.path + '#scrollbar=0&view=Fit'"
            class="file-show__file"></object>

    <!-- IMAGE -->
    <img v-else-if="isFileImg"
         v-bind="$attrs"
         v-on="$listeners"
         :src="value.path"
         class="file-show__file"/>

    <!-- OTHER -->
    <div v-else
         v-bind="$attrs"
         v-on="$listeners"
         :style="{ backgroundImage: 'url(' + fileImg + ')' }"
         class="file-show__file  _placeholder">
    </div>
  </div>
</template>

<script>
  import fileImg from '../assets/img/svg/file-types/other.svg'

  import {
    IMAGES_MIME_TYPES,
    ALLOWED_IMAGES_EXTS,

    VIDEOS_MIME_TYPES,
    ALLOWED_VIDEOS_EXTS,

    PDF_MIME_TYPES,
    ALLOWED_PDF_EXTS,
  } from '../constants/files'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      onlyShow: Boolean
    },
    data() {
      return {
        fileImg
      }
    },
    computed: {
      isFileVideo() {
        const file = this.value
        if (file.type) {
          return VIDEOS_MIME_TYPES.includes(file.type.toLowerCase())
        } else if(file.ext) {
          return ALLOWED_VIDEOS_EXTS.includes(file.ext.toLowerCase())
        }

        return false
      },
      isFilePdf() {
        const file = this.value
        if (file.type) {
          return PDF_MIME_TYPES.includes(file.type.toLowerCase())
        } else if(file.ext) {
          return ALLOWED_PDF_EXTS.includes(file.ext.toLowerCase())
        }

        return false
      },
      isFileImg() {
        const file = this.value
        if (file.type) {
          return IMAGES_MIME_TYPES.includes(file.type.toLowerCase())
        } else if(file.ext) {
          return ALLOWED_IMAGES_EXTS.includes(file.ext.toLowerCase())
        }

        return false
      },
      selector() {
        return  {
          '_video': this.isFileVideo,
          '_pdf': this.isFilePdf,
          '_image': this.isFileImg,
          '_other': !this.isFileVideo && !this.isFilePdf && !this.isFileImg,
        }
      }
    },
    methods: {

    }
  }
</script>

<style lang="less">

</style>
